__webpack_require__.p = "/pgn_printable_scoresheet/";